import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { getStudents } from '../../lib/api'
import { keys } from '../../lib/queryKeys'
import { PageHeader } from '../../components/PageHeader'
import { Entry, EntryList } from '../../components/Entry'
import { balanceShort } from '../../lib/balance'
import { waLink } from '../../lib/phone'
import { m } from '../../paraglide/messages'
import type { Student } from '../../types'

export const Route = createFileRoute('/students/')({
  component: StudentsPage,
})

const actionCls = 'border border-zinc-300 px-2 py-1 text-xs hover:bg-zinc-100 whitespace-nowrap'

function StudentsPage() {
  const navigate = useNavigate()

  const { data, isLoading, error } = useQuery<Student[]>({
    queryKey: keys.students,
    queryFn:  getStudents,
  })

  if (isLoading) return <p className="text-zinc-400">{m.loading()}</p>
  if (error) return <p className="text-red-600 text-sm">{(error as Error).message}</p>

  const students = data ?? []

  return (
    <div>
      <PageHeader title={m.students_title()}>
        <Link
          to="/students/new"
          className="border border-zinc-900 px-3 py-1.5 text-sm hover:bg-zinc-100"
        >
          {m.students_new()}
        </Link>
      </PageHeader>

      <EntryList isEmpty={students.length === 0} emptyMessage={m.students_empty()}>
        {students.map((s) => {
          const wa = waLink(s.whatsappPhone)
          return (
            <Entry
              key={s.id}
              onClick={() => navigate({ to: '/students/$id', params: { id: String(s.id) } })}
              title={s.name}
              meta={balanceShort(Number(s.balance))}
              actions={
                <>
                  {wa && (
                    <a
                      href={wa}
                      target="_blank"
                      rel="noreferrer"
                      title={m.messages_start_whatsapp()}
                      className={actionCls}
                    >
                      {m.students_action_whatsapp()}
                    </a>
                  )}
                  <button
                    title={m.messages_start_whatsapp()}
                    onClick={() => navigate({ to: '/messages', search: { student: s.id } })}
                    className={actionCls}
                  >
                    {m.students_action_message()}
                  </button>
                  <Link
                    to="/students/$id"
                    params={{ id: String(s.id) }}
                    className={actionCls}
                  >
                    {m.action_edit()}
                  </Link>
                </>
              }
            />
          )
        })}
      </EntryList>
    </div>
  )
}
